import { render, staticRenderFns } from "./document-edit-button.vue?vue&type=template&id=05b6074b"
import script from "./document-edit-button.vue?vue&type=script&lang=js"
export * from "./document-edit-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports